import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME, CUSTOM_LOCATIONS} from "../../variables";

class LocationController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "location";
    this.walkthroughState = WALKTHROUGH_STATES.LOCATION;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;

    this.forced_remote_job = false;

    if (!this.$auth.isAdmin()) this.hide_remote_job = true;

    this.PostAJobGlobalApiSyncListener = this.$rootScope.$on("PostAJobGlobalApiSync", ($event, params) => {
      this.syncApi();
    });

    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncListener);
  }

  syncApi() {
    this.determineRemoteState();

    if (this.event && this.event.contactInfo && this.event.contactInfo.streetLine1) {
      if (this.event.remote_job) return console.warn("Ignoring remote job api sync");

      this.$timeout(() => {
        this.geocoder.query(this.event.contactInfo.streetLine1 + " " + this.event.contactInfo.city);
      });
    }
  }

  determineRemoteState() {
    console.log(this.event);

    if (
      ((this.event && this.event.shifts && this.event.shifts.length && this.event.shifts[0] && this.event.shifts[0].id) ||
        (this.event && this.event.clonedFrom)) &&
      this.event.remote_job
    ) {
      this.forced_remote_job = true;
    } else {
      this.forced_remote_job = false;
    }

    if (
      ((this.event && this.event.shifts && this.event.shifts.length && this.event.shifts[0] && this.event.shifts[0].id) ||
        (this.event && this.event.clonedFrom)) &&
      !this.event.remote_job
    ) {
      this.hide_remote_job = true;
    }

    console.log("this.forced_remote_job:", this.forced_remote_job);
  }

  updateShift(shift, contactInfo) {
    if (!shift.id) {
      return console.warn("Trying to update shift without an ID");
    }

    if (shift.contactInfo.lat === contactInfo.lat && shift.contactInfo.lng === contactInfo.lng)
      return console.warn("Needless shift update: (", contactInfo.lat, ",", contactInfo.lng, ")");

    var tempShift = {
      id: shift.id,
      contactInfo,
    };

    this.$events.updateExistingShift(tempShift, true).then(
      (data) => {
        console.log("Updated shift:", data);
      },
      (err) => { }
    );
  }

  $onInit() {
    mapboxgl.accessToken = this.$env.EnvironmentConfig.mapbox;

    this.determineRemoteState();

    this.$timeout(() => {
      const map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/streets-v11",
        center: [-71.1103692, 42.3145186],
        zoom: 8,
      });

      this.map = map;

      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        countries: "us",
        localGeocoder: this.forwardGeocoder.bind(this),
        types: "address",
        filter: (item) => {
          return item.address;
        },
      });

      geocoder.on("result", (data) => {

        if (this.event.remote_job) return console.warn("Ignoring remote job update");

        const location = data.result;

        let contactInfo = {
          lng: location.center[0],
          lat: location.center[1],
          streetLine1: `${location.address} ${location.text}`,
          city: "",
          state: "",
          zipCode: "",
        };

        location.context.forEach((c) => {
          if (c.id.indexOf("postcode") !== -1) {
            contactInfo.zipCode = c.text;
          }
          if (c.id.indexOf("place") !== -1) {
            contactInfo.city = c.text;
          }
          if (c.id.indexOf("region") !== -1) {
            contactInfo.state = this.convertState(c.text);
          }
        });

        this.$timeout(() => {
          this.event.contactInfo = contactInfo;
          this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
        });

        if (this.event.id) {
          this.event.shifts.map((shift) => {
            this.updateShift(shift, contactInfo);
          });
        }

        console.log("what is event in location");
        console.dir(this.event);

      });

      geocoder.on("clear", (data) => {
        if (this.event.remote_job) return console.warn("Ignoring remote job clear");

        let contactInfo = null;

        this.$timeout(() => {
          this.event.contactInfo = contactInfo;
          this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
        });
      });

      document.getElementById("geocoder").appendChild(geocoder.onAdd(map));

      this.geocoder = geocoder;

      if (this.event && this.event.contactInfo && this.event.contactInfo.streetLine1) {
        if (this.event.remote_job) return console.warn("Ignoring remote job init query");

        this.$timeout(() => {
          console.log("contactInfo", this.event.contactInfo);
          geocoder.query(this.event.contactInfo.streetLine1 + " " + this.event.contactInfo.city);
        });
      }

      if (this.event.remote_job) {
        geocoder.setInput("Anywhere, USA");
        map.flyTo({
          center: [-87.6500523, 41.850033],
          zoom: 1,
          speed: 3,
        });

        const inputs = document.querySelectorAll("input.mapboxgl-ctrl-geocoder--input");
        inputs.forEach((input) => (input.disabled = true));
      }
    });
  }

  forwardGeocoder(query) {
    console.log("forwardGeocoder query", query);
    const matchingFeatures = [];
    for (const feature of CUSTOM_LOCATIONS.features) {
      if (
        feature.properties.title.toLowerCase().includes(query.toLowerCase()) ||
        feature.properties.title.toLowerCase().replace(",", "").includes(query.toLowerCase())
      ) {
        console.log("Custom Property Match:", feature.properties.title);
        feature["center"] = feature.geometry.coordinates;
        feature["place_type"] = ["address"];
        matchingFeatures.push(feature);
      }
    }
    return matchingFeatures;
  }

  updateRemoteJob() {
    if (this.event.remote_job) {
      this.geocoder.setInput("Anywhere, USA");
      this.map.flyTo({
        center: [-87.6500523, 41.850033],
        zoom: 1,
        speed: 3,
      });

      this.event.contactInfo = null;

      const inputs = document.querySelectorAll("input.mapboxgl-ctrl-geocoder--input");
      inputs.forEach((input) => (input.disabled = true));
    } else {
      this.geocoder.setInput("");

      const inputs = document.querySelectorAll("input.mapboxgl-ctrl-geocoder--input");
      inputs.forEach((input) => (input.disabled = false));
    }

    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
  }

  convertState(state) {
    const STATES = {
      Alabama: "AL",
      Alaska: "AK",
      "American Samoa": "AS",
      Arizona: "AZ",
      Arkansas: "AR",
      California: "CA",
      Colorado: "CO",
      Connecticut: "CT",
      Delaware: "DE",
      "District Of Columbia": "DC",
      "Federated States Of Micronesia": "FM",
      Florida: "FL",
      Georgia: "GA",
      Guam: "GU",
      Hawaii: "HI",
      Idaho: "ID",
      Illinois: "IL",
      Indiana: "IN",
      Iowa: "IA",
      Kansas: "KS",
      Kentucky: "KY",
      Louisiana: "LA",
      Maine: "ME",
      "Marshall Islands": "MH",
      Maryland: "MD",
      Massachusetts: "MA",
      Michigan: "MI",
      Minnesota: "MN",
      Mississippi: "MS",
      Missouri: "MO",
      Montana: "MT",
      Nebraska: "NE",
      Nevada: "NV",
      "New Hampshire": "NH",
      "New Jersey": "NJ",
      "New Mexico": "NM",
      "New York": "NY",
      "North Carolina": "NC",
      "North Dakota": "ND",
      "Northern Mariana Islands": "MP",
      Ohio: "OH",
      Oklahoma: "OK",
      Oregon: "OR",
      Palau: "PW",
      Pennsylvania: "PA",
      "Puerto Rico": "PR",
      "Rhode Island": "RI",
      "South Carolina": "SC",
      "South Dakota": "SD",
      Tennessee: "TN",
      Texas: "TX",
      Utah: "UT",
      Vermont: "VT",
      "Virgin Islands": "VI",
      Virginia: "VA",
      Washington: "WA",
      "West Virginia": "WV",
      Wisconsin: "WI",
      Wyoming: "WY",
    };

    return STATES[state];
  }

  goNext() {
    this.$tracking.reportPostAJobSubmitStep("location");
    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
  }
}

LocationController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default LocationController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/location/location.controller.js